
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"41","height":"40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#002E6B"}},[_c('path',{attrs:{"d":"M.889 33.778v.889h19.555V8.889H0v25.778h.889v-.89h.889v-23.11h16.889v22.222H.889v.889h.889z"}}),_c('path',{attrs:{"d":"M19.556 16.889H.889v1.778h18.667m0 3.555H.889V24h18.667m0 3.556H7.11v1.777h12.445"}}),_c('path',{attrs:{"d":"M14.222 33.778v-16h-1.778v16m-4.444 0v-16H6.222v16"}}),_c('path',{attrs:{"d":"M11.556 8V2.667a.89.89 0 0 1 .888-.89h20.077l6.59 6.591v28.965a.89.89 0 0 1-.889.89H12.444a.89.89 0 0 1-.888-.89v-1.777H9.778v1.777A2.667 2.667 0 0 0 12.444 40h25.778a2.667 2.667 0 0 0 2.667-2.667V7.632L33.257 0H12.444a2.667 2.667 0 0 0-2.666 2.667V8h1.778z"}}),_c('path',{attrs:{"d":"M37.333 8H32.89V3.556h-1.78v6.222h6.222zm-11.555 9.778v-.89a3.556 3.556 0 1 0 0 7.112 3.556 3.556 0 0 0 0-7.111v1.778a1.78 1.78 0 0 1 1.778 1.777 1.78 1.78 0 0 1-1.778 1.778A1.78 1.78 0 0 1 24 20.444a1.78 1.78 0 0 1 1.778-1.777v-.89zm8 12.444v-.889A1.78 1.78 0 0 1 32 27.556a1.78 1.78 0 0 1 1.778-1.778 1.78 1.78 0 0 1 1.778 1.778 1.78 1.78 0 0 1-1.778 1.777v1.778a3.556 3.556 0 1 0 0-7.111 3.556 3.556 0 0 0 0 7.111v-.889zm-8.19.55l9.777-12.445-1.397-1.099-9.778 12.445"}})])])
          )
        }
      }
    